<template>
  <div>

  <div class="row vpad"> 
    <div class="col s12 yo-align-center"><img src="../assets/logo.png" style="height:70px;"/></div>
  </div>

<div class="title_h1 yo-color-primary" style="margin-top:30px;">RICHIESTA DI ISCRIZIONE ANNULLATA</div>
<br />
Magari deciderai di registrarti la prossima volta
<br />
Grazie per l'interesse
<br />
La segreteria {{$socio.sigla}}
   



  </div>
</template>

<script>
export default {
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
